<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          {{ $t('Редактирование информации о торговой секции') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <ValidationObserver ref="section" @keydown.native.enter="focusOnBtn('continueBtn')">
          <validatable-text-input
              v-model="section.nameRu"
              rules="required"
              :label="$t('Наименование (рус.)')" />
          <validatable-text-input
              v-model="section.nameEn"
              rules="required"
              :label="$t('Наименование (англ.)')" />
          <v-checkbox
              v-if="!!section.id"
              v-model="section.isLocked"
              :label="$t('Заблокирована')" />
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import { mapActions, mapState } from 'vuex'
  import { PRODUCT_SECTION_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      ValidatableTextInput,
      GeneralError
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            id: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        section: {
          id: null,
          nameRu: null,
          nameEn: null,
          isLocked: false
        }
      }
    },
    computed: {
      ...mapState(PRODUCT_SECTION_MANAGEMENT.NAMESPACE, {
        currentSection: state => (state[PRODUCT_SECTION_MANAGEMENT.STATE.CURRENT] || { })
      })
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (!vm.dialogProp.id) {
          return
        }
        vm.getProductSectionInfo()
      })
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(PRODUCT_SECTION_MANAGEMENT.NAMESPACE, {
        getProductSectionInfoAction: PRODUCT_SECTION_MANAGEMENT.ACTIONS.GET_PRODUCT_SECTION_INFO,
        clearProductSectionInfoAction: PRODUCT_SECTION_MANAGEMENT.ACTIONS.CLEAR_PRODUCT_SECTION_INFO
      }),
      clearStore: async function () {
        return Promise.all(
          [
            this.clearProductSectionInfoAction()
          ])
      },
      getProductSectionInfo: async function () {
        try {
          this.isLoading = true
          await this.getProductSectionInfoAction({
            id: this.dialogProp.id
          })
          this.isLoading = false
          this.mapFields(this.currentSection)
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      mapFields: function (section) {
        this.section.id = this.dialogProp.id
        this.section.nameRu = section.nameRu
        this.section.nameEn = section.nameEn
        this.section.isLocked = section.isLocked
      },
      continueOperation: async function () {
        try {
          const result = await this.$refs.section.validate()
          if (!result) {
            return
          }
          this.isLoading = true

          if (this.dialogProp.callback) {
            await this.dialogProp.callback(this.section)
          }
          this.isLoading = false
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
          // проверка или сохранение формы неуспешно, остаемся в диалоговом окне
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
